/* eslint-disable */
import Vue from "vue";

export default () => {
  /*
若发布时间为
1分钟内，显示 刚刚
1小时内，显示 XX分钟前
1小时~昨天之前，显示 XX小时前

当年发布的显示MM-dd，
不是当年的，显示 yyyy-MM-dd
*/
  Vue.filter("newHours", function (timespan) {
    // 因为我接口得到的数据是 日期的格式，所有先转为了时间戳
    // 2021-01-28 18:34:28 改为时间戳
    let thisTime = timespan;

    thisTime = thisTime.replace(/-/g, "/");
    let time = new Date(thisTime);
    time = time.getTime(); // 此时的time就是为时间戳格式
    let date = new Date();
    var theCurrentYear = date.getFullYear(); //获取当前年的时间
    var dateTime = new Date(time); // 将传进来的字符串或者毫秒转为标准时间
    var year = dateTime.getFullYear();
    var month = dateTime.getMonth() + 1;
    var day = dateTime.getDate();
    var hour = dateTime.getHours();
    var minute = dateTime.getMinutes();
    // var second = dateTime.getSeconds()
    var millisecond = dateTime.getTime(); // 将当前编辑的时间转换为毫秒
    var now = new Date(); // 获取本机当前的时间
    var nowNew = now.getTime(); // 将本机的时间转换为毫秒
    var milliseconds = 0;
    var timeSpanStr;
    milliseconds = nowNew - millisecond;
    if (milliseconds <= 1000 * 60 * 1) {
      // 小于一分钟展示为刚刚
      timeSpanStr = "刚刚";
    } else if (1000 * 60 * 1 < milliseconds && milliseconds <= 1000 * 60 * 60) {
      // 大于一分钟小于一小时展示为分钟
      timeSpanStr = Math.round(milliseconds / (1000 * 60)) + "分钟前";
    } else if (
      1000 * 60 * 60 * 1 < milliseconds &&
      milliseconds <= 1000 * 60 * 60 * 24
    ) {
      // 大于一小时小于一天展示为小时
      timeSpanStr = Math.round(milliseconds / (1000 * 60 * 60)) + "小时前";
    } else if (1000 * 60 * 60 * 24 < milliseconds && year == theCurrentYear) {
      // 大于一天，且是当前年
      timeSpanStr = month + "-" + day; // 第二天，显示昨天 xx:xx
    } else {
      // 显示 2021.10.29 14:00
      timeSpanStr = year + "-" + month + "-" + day;

      // timeSpanStr = year + "." + month + "." + day + " " + hour + ":" + minute;
    }
    return timeSpanStr;
  });

  //年月日过滤器
  Vue.filter("GetHours", function (value) {
    const s = 1000,
      m = 60 * s,
      h = 60 * m,
      d = 24 * h,
      mo = 30 * d,
      y = 365 * d;

    const fdate = [
      {
        time: y,
        text: "年"
      },
      {
        time: mo,
        text: "月"
      },
      {
        time: d,
        text: "天"
      },
      {
        time: h,
        text: "小时"
      },
      {
        time: m,
        text: "分钟"
      },
      {
        time: s,
        text: "秒"
      }
    ];
    const time = Date.now() - new Date(value);
    for (let i = 0; i < fdate.length; i++) {
      const t = time / fdate[i].time;
      if (t >= 1) {
        return Math.floor(t) + fdate[i].text + "前";
      }
    }
  });

  //年月日过滤器
  Vue.filter("GetHours2", function (value, fmt) {
    //得到今天时间戳
    var timestamp = new Date();
    let Y1 = timestamp.getFullYear();
    let M1 = timestamp.getMonth() + 1;
    let D1 = timestamp.getDate();
    if (M1 < 10) {
      M1 = "0" + M1;
    }

    if (D1 < 10) {
      D1 = "0" + D1;
    }

    let b = Y1 + "-" + M1 + "-" + D1;

    var myDate = new Date(value);
    let Y2 = myDate.getFullYear();
    let M2 = myDate.getMonth() + 1;
    let D2 = myDate.getDate();
    if (M2 < 10) {
      M2 = "0" + M2;
    }

    if (D2 < 10) {
      D2 = "0" + D2;
    }
    let a = Y2 + "-" + M2 + "-" + D2;
    // return (
    //   myDate.getFullYear() +
    //   "-" +
    //   (myDate.getMonth() + 1) +
    //   "-" +
    //   myDate.getDate()
    // );

    //判断是否今天

    if (a == b) {
      const s = 1000,
        m = 60 * s,
        h = 60 * m,
        d = 24 * h,
        mo = 30 * d,
        y = 365 * d;

      const fdate = [
        {
          time: y,
          text: "年"
        },
        {
          time: mo,
          text: "月"
        },
        {
          time: d,
          text: "天"
        },
        {
          time: h,
          text: "小时"
        },
        {
          time: m,
          text: "分钟"
        },
        {
          time: s,
          text: "秒"
        }
      ];
      const time = Date.now() - new Date(value);
      for (let i = 0; i < fdate.length; i++) {
        const t = time / fdate[i].time;
        if (t >= 1) {
          return Math.floor(t) + fdate[i].text + "前";
        }
      }
    } else {
      if (value) {
        var myDate = new Date(value);
        var o = {
          "M+": myDate.getMonth() + 1, //月份
          "d+": myDate.getDate(), //日
          "h+": myDate.getHours(), //小时
          "m+": myDate.getMinutes(), //分
          "s+": myDate.getSeconds(), //秒
          "q+": Math.floor((myDate.getMonth() + 3) / 3), //季度
          S: myDate.getMilliseconds() //毫秒
        };
        if (/(y+)/.test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            (myDate.getFullYear() + "").substr(4 - RegExp.$1.length)
          );
        for (var k in o)
          if (new RegExp("(" + k + ")").test(fmt))
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length == 1
                ? o[k]
                : ("00" + o[k]).substr(("" + o[k]).length)
            );
        return fmt;
      } else {
        return "";
      }
    }
  });
  //年月日过滤器
  Vue.filter("GetHours3", function (value) {
    const s = 1000,
      m = 60 * s,
      h = 60 * m,
      d = 24 * h,
      mo = 30 * d,
      y = 365 * d;

    const fdate = [
      {
        time: y,
        text: "年"
      },
      {
        time: mo,
        text: "月"
      },
      {
        time: d,
        text: "天"
      },
      {
        time: h,
        text: "小时"
      },
      {
        time: m,
        text: "分钟"
      },
      {
        time: s,
        text: "秒"
      }
    ];
    const time = new Date(value) - Date.now();
    for (let i = 0; i < fdate.length; i++) {
      const t = time / fdate[i].time;
      if (t >= 1) {
        return Math.floor(t) + fdate[i].text;
      }
    }
  });
  //年月日过滤器
  Vue.filter("GetYMD", function (value) {
    var myDate = new Date(value);
    return (
      myDate.getFullYear() +
      "-" +
      (myDate.getMonth() + 1) +
      "-" +
      myDate.getDate()
    );
  });
  //年月日时分秒过滤器
  Vue.filter("GetYMDHMS", function (value, fmt) {
    if (value) {
      var myDate = new Date(value.replace(/-/g, "/"));
      var o = {
        "y+":myDate.getFullYear(),//年
        "M+": myDate.getMonth() + 1, //月份
        "d+": myDate.getDate(), //日
        "h+": myDate.getHours(), //小时
        "m+": myDate.getMinutes(), //分
        "s+": myDate.getSeconds(), //秒
        "q+": Math.floor((myDate.getMonth() + 3) / 3), //季度
        S: myDate.getMilliseconds() //毫秒
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          (myDate.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
      return fmt;
    } else {
      return "";
    }
  });
  //表情代码转换图片过滤器
  Vue.filter("GetIMG", function (value) {
    var str = value.replace(
      /\[em_([0-9]*)\]/g,
      '<img src="../../static/js/qqemotion/arclist/$1.gif" border="0" />'
    );
    return str;
  });
  //截取字数过滤器
  Vue.filter("GetSubstring", function (value, num) {
    if (value == "" || value == null || value == undefined) {
      return "";
    } else {
      return value.length > num
        ? value.substring(0, num) + "..."
        : value.substring(0, num);
    }
  });
  //截取字数过滤器
  Vue.filter("toFixed", function (value, num) {
    if (value == "0") {
      return "0.00";
    } else if (
      value == "" ||
      value == null ||
      value == undefined ||
      isNaN(value)
    ) {
      return "";
    } else {
      return value.toFixed(num);
    }
  });
  // 封面拼接
  Vue.filter("getImg", function (url) {
   if (url) {
   	const regex = /http/i
   	if(regex.test(url)){
   		return url;
   	}else{
   		return 'https://xytvadmin.hlrmt.com' + url;
			// return "http://192.168.1.99:8111" + url; //测试

   	}
   }else {
     return '';
   }
  });
};



// WEBPACK FOOTER //
// ./src/utils/filter.js